import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    rowGap: 16,
  },
}))

export default useStyles
